import { HttpTimeoutError } from '@cian/peperrors/shared';
import { CircuitBreakerError } from '../../errors/circuitBreakerError.mjs';
import { getCircuitBreaker } from '../circuitBreaker/circuitBreakersStore.mjs';

class CircuitBreakerHook {
    requestConfig;
    circuitBreaker;
    constructor(params) {
        this.requestConfig = params.requestConfig;
        this.circuitBreaker = getCircuitBreaker(params.context.requestHash, {
            failureTreshold: params.context.failureTreshold,
            samplingDuration: params.context.samplingDuration,
            minimumSamples: params.context.minimumSamples,
            maximumSamples: params.context.maximumSamples,
            openDuration: params.context.openDuration,
            maxTimeForHalfOpenRequest: params.context.maxTimeForHalfOpenRequest,
        });
    }
    onRequest() {
        if (!this.circuitBreaker.canRunTask()) {
            throw new CircuitBreakerError(this.requestConfig.url.origin + this.requestConfig.url.pathname);
        }
    }
    onResponse() {
        this.circuitBreaker.recordSuccess();
    }
    onError(err) {
        if (err instanceof HttpTimeoutError) {
            this.circuitBreaker.recordFailure();
        }
        else if (!(err instanceof CircuitBreakerError)) {
            this.circuitBreaker.recordSuccess();
        }
    }
}

export { CircuitBreakerHook };
//# sourceMappingURL=CircuitBreakerHook.mjs.map
